import TagTypes from '../../constants/TagTypes';
import { tags_type_count_$gte } from '../../utils/query-helpers';

const timestamp = new Date().toISOString();

const REQUIRED_FIELDS_PUBLIC = {
  $and: [
    // Must provide activity type and description
    {
      activityId: {
        $null: false
      }
    },
    {
      siteId: {
        $null: false
      }
    },
    {
      interactionDescription: {
        $not: ''
      }
    },
    // Date must be provided and in the future
    {
      $or: [
        {
          $and: [
            {
              specificDate: 'Yes'
            },
            {
              date: {
                $gte: timestamp
              }
            }
          ]
        },
        {
          $and: [
            {
              specificDate: 'No'
            },
            {
              startDate: {
                $null: false
              }
            },
            {
              endDate: {
                $gte: timestamp
              }
            }
          ]
        }
      ]
    },
    // Must specify a participant
    {
      ...tags_type_count_$gte(TagTypes.Participant, 1)
    },
    // Must specify a method of interaction
    {
      ...tags_type_count_$gte(TagTypes.InteractionType, 1)
    },
    // Must be visible, and not completed or cancelled
    {
      cancelled: false
    },
    {
      completed: false
    },
    {
      published: true
    }
  ]
}

export default REQUIRED_FIELDS_PUBLIC;
